export const GAME_STATUS = Object.freeze({
    IDLE: 'idle',
    RUNNING: 'running',
    PAUSED: 'paused',
    FINISHED: 'finished',
});

export const ITEM_TYPES = Object.freeze({
    GOOD_LEAD: 'goodLead',
    HOT_LEAD: 'hotLead',
    BONUS: 'bonus',
    BAD_ITEM: 'badItem',
    ACTIVITY_ITEM: 'activityItem',
});

export const OUTCOMES = Object.freeze({
    FINISHED: 'finished',
    DIED: 'died',
    SKIPPED: 'skipped',
});

export const GAME = Object.freeze({
    DEFAULT_DURATION: 90,
    INITIAL_LIVES: 3,
    MAX_ITEMS_ON_SCREEN: 5,
    /** Cap per-frame delta passed to physics (avoids spiral-of-death jumps). */
    MAX_FRAME_MS: 32,
    BOARD_SAFE_PADDING: 8,
    /** Floating items stack between base and max (overlays use higher layers in CSS). */
    ITEM_LAYER_BASE: 4,
    ITEM_LAYER_MAX: 8,
    /** Temporarily spawn and render activity cards only. */
    ACTIVITIES_ONLY: true,
    /** Interval factor when ACTIVITIES_ONLY (lower = faster spawns). */
    ACTIVITY_SPAWN_INTERVAL_SCALE: 0.36,
    /** Spawn rate ramps from slow to full speed over this many seconds (ease-in). */
    SPAWN_RAMP_SECONDS: 35,
    /** At game start, spawn interval is divided by this (lower = fewer items). */
    SPAWN_RAMP_MIN_MULTIPLIER: 0.05,
    /** Item drift uses the same ramp window; min fraction of base speed at t=0. */
    MOTION_RAMP_SECONDS: 35,
    MOTION_RAMP_MIN_MULTIPLIER: 0.28,
    /** Max simultaneous pop-burst overlays (performance). */
    MAX_BURST_EFFECTS: 4,
});

/**
 * Floating item drift — adjust speedPercentPerSecond for global pace.
 * Positions are in % of the board; speed is % per second.
 */
export const ITEM_MOTION = Object.freeze({
    speedPercentPerSecond: 6,
    speedJitter: 0.22,
    boundsPadding: 8,
    boundsRadius: 6,
    tiltDegrees: 14,
});

export const SCORING = Object.freeze({
    GOOD_LEAD: 100,
    HOT_LEAD: 250,
    BONUS: 500,
    BAD_ITEM: 100,
    ACTIVITY_ITEM: 150,
});

export const DIFFICULTY = Object.freeze({
    easy: {
        spawnIntervalMs: [1200, 1800],
        itemLifetimeMs: 2800,
        badChance: 0.14,
        activityChance: 0.1,
        hotLeadChance: 0.12,
        bonusChance: 0.06,
    },
    normal: {
        spawnIntervalMs: [800, 1300],
        itemLifetimeMs: 2400,
        badChance: 0.44,
        activityChance: 0.14,
        hotLeadChance: 0.1,
        bonusChance: 0.05,
    },
    hard: {
        spawnIntervalMs: [600, 1100],
        itemLifetimeMs: 1800,
        badChance: 0.3,
        activityChance: 0.16,
        hotLeadChance: 0.08,
        bonusChance: 0.04,
    },
});

export const GOOD_LEAD_NAMES = Object.freeze([
    'Ana García',
    'Carlos Ruiz',
    'Lucía Martín',
    'Sofía Torres',
    'Javier López',
    'Marta Vidal',
    'Diego Ramos',
    'Clara Soler',
    'Nora Ferrer',
    'Hugo Medina',
]);

export const GOOD_LEAD_SUBTITLES = Object.freeze([
    'Interesada en demo',
    'Pidió información',
    'Quiere precios',
    'Descargó catálogo',
    'Solicita llamada',
    'Abrió propuesta',
    'Visitó la web',
    'Busca proveedor',
]);
